import React from 'react';
import { cn, getStatusClass, formatStatus } from '@/lib/utils';

export const StatusBadge = ({ status, className }) => {
  return (
    <span 
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        getStatusClass(status),
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;
